import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import TopNav from "../components/TopNav";
import "./ChartersManagePage.css";


const ChartersManagePage = (props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [myCharterData, setMyCharterData] = useState(null);
    // const [refreshing, setRefreshing] = useState(false);

    useEffect(() => {
        getData();
        return () => {}
    }, []);

    // Listen for navigation state changes to refresh data
    useEffect(() => {
        if (location.state?.refresh) {
            getData();
            // Clear the state to prevent refetching on other navigation events
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location.state]);

    const getData = async () => {

        if(props.charterCert !== 0){

            console.log(props)
        }
        
        setLoading(true);
        setError(null);
        
        try {
            const { data } = await axios.get("/api/charters/manage", {
                params: {
                    iid: props.auth_iid,
                    _t: Date.now(),
                },
            });
            
            if (data) {

                console.log(data);

                if(data[0].message === "none"){
                    console.log(data)
                    console.log("No charter flights");
                    setMyCharterData([]);                    
                }else{
                    setMyCharterData(data);
                    localStorage.setItem("myCharterData", JSON.stringify(data));
                }

            } else {
                console.log("No data");
                setError("No charter data available.");
                setMyCharterData([]);
            }
        } catch (err) {
            console.error("API Error:", err);
            setError("Failed to fetch charter data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // const handleRefresh = async () => {
    //     setRefreshing(true);
    //     setError(null);
        
    //     try {
    //         await getData();
    //     } finally {
    //         setRefreshing(false);
    //     }
    // };
    const handleManage = () => {
        navigate('/charter-create');
    };    

    return (
        <React.Fragment>
            <TopNav page={props.page} darkMode={props.darkmode} />
            <div className={`charter-container ${props.darkmode ? "dark-theme" : "light-theme"}`}>
                {/* Header Section */}
                <div className="charter-header-section">
                    <div className="charter-title-group">
                        <h1>
                            {/* <span className="charter-icon"></span> */}
                            My Charter Flights
                        </h1>
                        <div className="charter-subtitle">
                            {myCharterData && <div>Total: {myCharterData.length}</div>}
                        </div>
                    </div>
                    <div className="button-group">
                        {props.charterCert > 0 &&
                            <button
                                className="btn btn-charter-new"
                                onClick={handleManage}
                            >
                            <span>Create</span>
                            </button>
                        }
                        {/* <button
                            className="btn btn-refresh"
                            onClick={handleRefresh}
                            disabled={refreshing || loading}
                        >
                            {refreshing ? (
                                <>
                                    <span className="loading-spinner"></span>
                                    Refreshing...
                                </>
                            ) : (
                                <>
                                    <span>Refresh</span>
                                </>
                            )}
                        </button> */}
                    </div>
                </div>

                {/* Error Message */}
                {error && (
                    <div className="charter-card">
                        <div className="info-box error">
                            <strong>Error:</strong> {error}
                        </div>
                    </div>
                )}

                {/* Loading State */}
                {loading && !myCharterData && (
                    <div className="charter-card">
                        <div className="loading-container">
                            <span className="loading-spinner"></span>
                            <p>Loading charter flights...</p>
                        </div>
                    </div>
                )}

                {/* Charter Flights List */}
                {myCharterData && myCharterData.length === 0 && !loading && (
                    <div className="charter-card">
                        <div className="info-box warning">
                            <strong>NONE</strong>: You currently have no charters in the system. 
                            
                        </div>
                    </div>
                )}

                {myCharterData && myCharterData.length > 0 && (
                    <div className="charter-stats">
                        <div className="stat-box">
                            <span className="stat-label">
You currently have {myCharterData.length} charter flight{myCharterData.length !== 1 ? 's' : ''} in the system.  Create
a new charter flight by clicking the "Create" button above.                                
                            </span>
                        </div>
                    </div>
                )}

                {myCharterData && myCharterData.map((chdata, index) => (
                    <div key={index} className="charter-card">
                        {/* Airport Names Header */}
                        <div className="charter-airports-header">
                            <div className="airport-info">
                                <span className="airport-label">Origin Airport:</span>
                                <span className="airport-name">{chdata.origin_airport}</span>
                            </div>
                            <div className="airport-info">
                                <span className="airport-label">Destination Airport:</span>
                                <span className="airport-name">{chdata.dest_airport}</span>
                            </div>
                        </div>

                        {/* Charter Table */}
                        <div className="charter-table-container">
                            <table className="charter-table">
                                <thead>
                                    <tr>
                                        <th>Orig</th>
                                        <th>Dest</th>
                                        <th>NM</th>
                                        <th>Created</th>
                                        <th>Last Flown</th>
                                        <th>Flights</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{chdata.orig_code}</td>
                                        <td>{chdata.dest_code}</td>
                                        <td>{chdata.distance_nm} nm</td>
                                        <td>{chdata.creation_date}</td>
                                        <td>{chdata.last_flown_date || 'N/A'}</td>
                                        <td>{chdata.count}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        {/* Charter Details Footer */}
                        <div className="charter-details-footer">

                            <div className="footer-item">
                                <span className="footer-label">Times Flown:</span>
                                <span className="footer-value">{chdata.count}</span>
                            </div>
                            <div className="footer-item">
                                <span className="footer-label">Cost:</span>
                                <span className="footer-value">${chdata.cost || '0'}</span>
                            </div>
                            <div className="footer-item">
                                <span className="footer-label">Earnings:</span>
                                <span className="footer-value">${chdata.earnings || '0'}</span>
                            </div>
                            <div className="footer-item">
                                <span className="footer-label">Expires:</span>
                                <span className="footer-value">{chdata.expiration_date || 'N/A'}</span>
                            </div>
                            <div className="footer-item">
                                <button 
                                    className="btn btn-primary" 
                                    onClick={() => navigate('/routes', { state: { route: { orig: chdata.orig_code, dest: chdata.dest_code } } })}
                                    style={{ padding: '5px 15px', fontSize: '0.9rem' }}
                                >
                                    Fly
                                </button>
                            </div>                            
                        </div>
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
}

export default ChartersManagePage;
